import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export const ProtectedAdminRoute = ({ children }) => {
  const { status } = useAdminAuth();
  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-charcoal font-mono text-sm uppercase tracking-widest text-cream/60">
        Yükleniyor…
      </div>
    );
  }
  if (status !== "authed") return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedAdminRoute;
